import * as React from 'react';
import format from 'date-fns/format';

// Helpers
import { getCurrentLocale } from '../../../helpers/locale';

// Hooks
import { useFormCopy } from '../hooks/useFormCopy';

// Types
import { ISurveyTargetPeriod } from '../../../types';

interface InterpolatedFormCopyProps {
    copy?: string | null;
    data: Record<string, any>;
    targetperiod?: ISurveyTargetPeriod;
}

const parseTimePeriod = ({ month, year }: { month: number; year: number }): string => {
    const date = new Date();

    date.setMonth(month - 1);
    date.setFullYear(year);

    return format(date, 'MMMM yyyy', { locale: getCurrentLocale() });
};

export const InterpolatedFormCopy: React.FC<InterpolatedFormCopyProps> = ({ copy, data, targetperiod }) => {
    const parsedTargetPeriod =
        typeof targetperiod !== 'undefined'
            ? {
                  start: parseTimePeriod(targetperiod.start),
                  end: parseTimePeriod(targetperiod.end)
              }
            : {
                  start: null,
                  end: null
              };
    const interpolatedCopy = useFormCopy({
        copy,
        data: { ...data, targetPeriod: parsedTargetPeriod }
    });

    return <>{interpolatedCopy}</>;
};
